import axios from "axios";
import { items, categories } from "InitialData/Items";
import { listData } from "InitialData/accounts/navBoxData";

class FileRequester {
  instance = null;

  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_ORIGIN,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      origin: process.env.REACT_APP_ORIGIN,
      withCredentials: true,
    });
  }

  async upload(data, path = "") {
    try {
      let promise = new Promise((resolve, reject) => {
        let result = "";
        this.instance
          .post("store/uploads", data, {
            headers: {
              destination: path,
            },
          })
          .then((res) => {
            result = res.data;
          })
          .catch((ex) => {
            result = ex;
          })
          .finally(() => {
            resolve(result);
          });
      });
      let result = await promise;
      return result;
    } catch (e) {}
  }
  async download(url, name) {
    fetch(url, {
      method: "GET",
      mode: "cors",
      withCredentials: true,
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const element = document.createElement("a");

        element.setAttribute("href", url);
        const type = url.includes(".") ? url.split("\\.") : ["png"];
        element.setAttribute("download", `${name}.${type[type.length - 1]}`);

        document.body.appendChild(element);

        element.click();

        element.parentNode.removeChild(element);
        window.URL.revokeObjectURL(url);
      });
  }
}

export default FileRequester;
